module.exports = __webpack_public_path__ + "img/ic_car_info.36ee13ec.svg";